<template>
    <div class="subscription" v-if="data">
        <template v-if="['subscribe', 'edit', 'requestEdit', 'requestUnsubscribe', 'reconfirm'].includes(data.state)">
            <subscription-form
                :rubrics="newsList"
                :programs="programsList"
                :subscriber="data.subscriber"
                :state="data.state"
            />
        </template>
        <template v-if="data.state === 'unsubscribe'">
            <vue-raw class="text-size-lt u-bold u-line-height-1_2" :raw="text.unsubscribeTitle"/>
            <vue-raw class="u-top-margin--s text-size-l" :raw="text.unsubscribeDescription"/>
        </template>
        <template v-if="data.state === 'confirm'">
            <vue-raw class="text-size-lt u-bold u-line-height-1_2" :raw="text.confirmTitle"/>
            <div class="u-top-margin--s text-size-l">
                <vue-raw tag="span" :raw="text.confirmDescription"/>
                <z-link
                    :href="`./?id=${data.subscriber?.id}&confirm-code=${data.subscriber['confirm-code']}&email=${data.subscriber?.email}&state=edit`"
                    :underlined="false"
                >
                    <span v-html="text.manageSubscriptionLink"></span>
                </z-link>
            </div>
        </template>
        <template v-if="data.state === 'error'">
            <span class="text-size-lt u-bold u-line-height-1_2">
                <z-icon class="subscription__icon" name="general/warning"/>
                <vue-raw tag="span" :raw="text.defaultError"/>
            </span>
        </template>
    </div>
</template>

<script setup>
import { ref, computed } from 'vue'
import { useGetter } from '@/composable/useGetter'
import SubscriptionForm from './components/SubscriptionForm.vue'
import { text } from './locales'

const {app} = useGetter(['app'])
const data = ref(app.value.components?.subscription)

const newsList = computed(() => {
    return data.value?.rubrics.filter(item => item.type === 'news')
})
const programsList = computed(() => {
    return data.value?.rubrics.filter(item => item.type === 'programs')
})
</script>

<style lang="scss">
.subscription {
    border-radius: 10px;

    max-width: 1100px;

    &__icon {
        margin-top: -0.2em;
        margin-right: var(--spacer-2xs);
        width: 1.2em;
        height: 1.2em;
    }
}
</style>
